var map = {
	"./AllosetricProteinRegulation/Picture1.jpg": 4423,
	"./AllosetricProteinRegulation/Picture2.jpg": 7928,
	"./AllosetricProteinRegulation/Picture3.jpg": 2757,
	"./ComputationalStructuralVirology/Picture1.jpg": 356,
	"./ComputationalStructuralVirology/Picture2.jpg": 67,
	"./ComputationalStructuralVirology/Picture3.png": 7474,
	"./ComputationalStructuralVirology/Picture4.png": 9197,
	"./GenerativeAIinBiomedicine/image1.jpg": 1842,
	"./GenerativeAIinBiomedicine/image2.png": 7565,
	"./GenerativeAIinBiomedicine/image3.jpg": 5232,
	"./GenerativeAIinBiomedicine/image4.png": 9275,
	"./GenerativeAIinBiomedicine/image5.jpg": 3926,
	"./HSP70.jpg": 6960,
	"./ICDD/Picture1.jpeg": 4557,
	"./ICDD/Picture2.jpg": 2035,
	"./ICDD/Picture3.png": 9442,
	"./MolecularChaperones/Picture1.png": 7800,
	"./MolecularChaperones/Picture2.png": 4659,
	"./MolecularChaperones/Picture3.png": 9434,
	"./MolecularChaperones/Picture4.png": 7381,
	"./ProteinKinases/Picture1.jpg": 4675,
	"./ProteinKinases/Picture2.jpg": 6548,
	"./ProteinKinases/Picture3.jpg": 3921,
	"./ProteinKinases/Picture4.jpg": 4690,
	"./ProteinKinases/Picture5.jpg": 7359,
	"./ProteinKinases/Picture6.jpg": 3024,
	"./ProteinKinases/Picture7.jpg": 3949,
	"./cancerCell.jpg": 9802,
	"./cancer_cell.jpg": 923,
	"./idk.jpg": 2266,
	"./kinasesMap.jpg": 8702,
	"./protein-and-lipid-kinases.jpg": 2315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9040;